<ng-container *ngIf="origin as connectedOrigin">
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="connectedOrigin"
    [cdkConnectedOverlayOpen]="open"
    [cdkConnectedOverlayPositions]="positions"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayFlexibleDimensions]="true"
    [cdkConnectedOverlayViewportMargin]="8"
    [cdkConnectedOverlayWidth]="overlayWidth"
    (backdropClick)="close()"
    (detach)="close()"
    (overlayKeydown)="onOverlayKeydown($event)"
  >
    <div
      class="shared-floating-dropdown dropdown-menu show"
      [ngClass]="panelClass"
      [style.min-width]="minWidth"
      [style.max-height]="maxHeight"
      (click)="$event.stopPropagation()"
    >
      <ng-content></ng-content>
    </div>
  </ng-template>
</ng-container>
